import ArrayUtil from '@leverege/array-util'

import Constants from '~/actions/Constants'

const initialState = {
  project : [],
  index : { }
};

function blueprints( state = initialState, action ) {

  switch ( action.type ) {

    case Constants.GET_PROJECT: {
      // TODO : MERGE IF STARTINDEX > 0
      const nIndex = Object.assign( state.index )
      const nProject = [].concat( state.project )
      const nState = { index : nIndex, project : nProject }

      action.project && action.project.blueprints && action.project.blueprints.forEach( ( bp ) => {
        nIndex[bp.id] = bp
        nProject.push( bp )
      } )
      return nState
    }

    case Constants.GET_BLUEPRINTS: {
      const nIndex = {} // Object.assign( state.index )
      const nProject = []
      const nState = { index : nIndex, project : nProject }

      action.blueprints.items.forEach( ( bp ) => {
        nIndex[bp.id] = bp
        nProject.push( bp )
      } )

      return nState
    }

    case Constants.ADD_BLUEPRINT: {

      const nState = copy( state )
      nState.index[action.blueprint.id] = action.blueprint
      nState.project.push( action.blueprint )
      
      return nState
    }

    case Constants.UPDATE_BLUEPRINT: {

      const nState = copy( state )
      nState.index[action.blueprint.id] = action.blueprint
      ArrayUtil.replace( nState.project, 'id', action.blueprint.id, action.blueprint )
      return nState
    }

    case Constants.REMOVE_BLUEPRINT: {
      
      const nState = copy( state )
      delete nState.index[action.blueprint.id]
      ArrayUtil.remove( nState.project, 'id', action.blueprint.id )

      return nState
    }

    default:
      return state

  }
}

function copy( state ) {
  const nIndex = Object.assign( state.index )
  const nProject = [].concat( state.project )
  return { index : nIndex, project : nProject }
}

module.exports = blueprints;
